module.exports = __webpack_public_path__ + "static/media/sinav_modu.6ffcf94c.jpg";